<dsy-sidebar
    *ngIf="!isMobile"
    specified-width="374px"
    z-index="100"
    transition-duration="0.5s"
    renderSide="right"
    header-content="Right sidebar"
    closes-on-apply="closesApply"
    closes-on-background-interaction="true"
    background-overlay
    is-scrollable
    headerContent="{{ header }}"
    defaultHeaderContent="{{ defaultHeaderContent }}"
    [cancelButtonDisabled]="false"
    [handleOpenCloseInteraction]="handleOpenCloseInteraction"
    [isOpen]="isOpen()"
    background-overlay-present="true"
    [headerSlotCustomContainerStyle]="'box-shadow: none'"
  >
  <span></span>
  <span class="m-3"></span>
  <dsy-input-dropdown
    *ngIf="entries"
    [closesOnSelection]="true"
    [entries]="entries"
    [exclusiveSelection]="true"
    id="dropdown"
    label="{{ 'DISPATCH_LIST.SORT_BY.LABEL' | translate }}"
    density="default"
    class="input-sidebar"
    data-qaa="sort-dropdown"
    [handleChange]="onSortChange"
  ></dsy-input-dropdown>
  <dsy-divider
    divider-orientation="horizontal"
    divider-color="light-grey"
    class="divider"
    style="padding-top: 24px;"
  ></dsy-divider>
  <dsy-card
    card-color="#ffffff"
    height="auto"
    round-border="true"
    no-padding="true"
  >
    <div class="mt-2 mb-2 container-title" data-qaa="current-events-title">
      <span class="text-title"> {{ 'DISPATCH_LIST.EVENT_STATUS.CURRENT' | translate }} ({{currentEvents.length}}) </span>
      <mat-icon *ngIf="showCurrent"
        class="dropdown-chip-close-icon"
        (click)="closeOpenCurrent()">keyboard_arrow_up
      </mat-icon>
      <mat-icon *ngIf="!showCurrent"
        class="dropdown-chip-close-icon"
        (click)="closeOpenCurrent()">keyboard_arrow_down
      </mat-icon>
    </div>
    <div *ngIf="showCurrent" data-qaa="current-events-list" class="sidebar-portfolio">
      <p class="text-no-event" *ngIf="currentEvents.length === 0">{{ 'DISPATCH_LIST.NO_EVENTS' | translate }}</p>
      <dsy-card
        card-color="#F7F8FB"
        height="auto"
        round-border="true"
        no-padding="true"
        *ngFor="let event of currentEvents; let i = index"
      >
        <app-portfolio-card [event]="event" [index]="i"></app-portfolio-card>
      </dsy-card>
    </div>
    <dsy-divider
      divider-orientation="horizontal"
      divider-color="light-grey"
      class="divider"
    >
    </dsy-divider>
    <div class="mt-2 mb-2 container-title" data-qaa="upcoming-events-title">
      <span class="text-title"> {{ 'DISPATCH_LIST.EVENT_STATUS.UPCOMING' | translate }} ({{upcomingEvents.length}}) </span>
      <mat-icon *ngIf="showUpcoming"
        class="dropdown-chip-close-icon"
        (click)="closeOpenUpcoming()">keyboard_arrow_up
      </mat-icon>
      <mat-icon *ngIf="!showUpcoming"
        class="dropdown-chip-close-icon"
        (click)="closeOpenUpcoming()">keyboard_arrow_down
      </mat-icon>
    </div>
    <div *ngIf="showUpcoming" data-qaa="upcoming-events-list" class="sidebar-portfolio">
      <p class="text-no-event" *ngIf="upcomingEvents.length === 0">{{ 'DISPATCH_LIST.NO_EVENTS' | translate }}</p>
      <dsy-card
        card-color="#F7F8FB"
        height="auto"
        round-border="true"
        no-padding="true"
        *ngFor="let event of upcomingEvents; let i = index"
      >
        <app-portfolio-card [event]="event" [index]="i"></app-portfolio-card>
      </dsy-card>
    </div>
    <dsy-divider
      divider-orientation="horizontal"
      divider-color="light-grey"
      class="divider"
    >
    </dsy-divider>
    <div class="mt-2 mb-2 container-title" data-qaa="completed-events-title">
      <span class="text-title"> {{ 'DISPATCH_LIST.EVENT_STATUS.COMPLETED' | translate }} ({{completedEvents.length}}) </span>
      <mat-icon *ngIf="showCompleted"
        class="dropdown-chip-close-icon"
        (click)="closeOpenCompleted()">keyboard_arrow_up
      </mat-icon>
      <mat-icon *ngIf="!showCompleted"
        class="dropdown-chip-close-icon"
        (click)="closeOpenCompleted()">keyboard_arrow_down
      </mat-icon>
    </div>
    <div *ngIf="showCompleted" data-qaa="completed-events-list" class="sidebar-portfolio">
      <p class="text-no-event" *ngIf="completedEvents.length === 0">{{ 'DISPATCH_LIST.NO_EVENTS' | translate }}</p>
      <dsy-card
        card-color="#F7F8FB"
        height="auto"
        round-border="true"
        no-padding="true"
        *ngFor="let event of completedEvents; let i = index"
      >
        <app-portfolio-card [event]="event" [index]="i"></app-portfolio-card>
      </dsy-card>
    </div>
  </dsy-card>
</dsy-sidebar>

<!-- Mobile bottom sheet -->
<ng-container *ngIf="isMobile">
  <div class="mobile-sheet-overlay" [class.open]="isOpen()" (click)="handleCancelButtonInteraction($event)"></div>
  <div class="mobile-sheet" [class.open]="isOpen()">
    <div class="mobile-sheet__header">
      <span class="mobile-sheet__header-title">{{ header }}</span>
      <button class="mobile-sheet__close" (click)="handleCancelButtonInteraction($event)"
              [attr.aria-label]="'DISPATCH_LIST.CANCEL' | translate">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="mobile-sheet__content">
      <dsy-input-dropdown
        *ngIf="entries"
        [closesOnSelection]="true"
        [entries]="entries"
        [exclusiveSelection]="true"
        id="dropdown-mobile"
        label="{{ 'DISPATCH_LIST.SORT_BY.LABEL' | translate }}"
        density="default"
        class="input-sidebar"
        data-qaa="sort-dropdown-mobile"
        [handleChange]="onSortChange"
      ></dsy-input-dropdown>
      <dsy-divider
        divider-orientation="horizontal"
        divider-color="light-grey"
        class="divider"
        style="padding-top: 24px;"
      ></dsy-divider>
      <dsy-card
        card-color="#ffffff"
        height="auto"
        round-border="true"
        no-padding="true"
      >
        <div class="mt-2 mb-2 container-title" data-qaa="current-events-title-mobile">
          <span class="text-title"> {{ 'DISPATCH_LIST.EVENT_STATUS.CURRENT' | translate }} ({{currentEvents.length}}) </span>
          <mat-icon *ngIf="showCurrent" class="dropdown-chip-close-icon" (click)="closeOpenCurrent()">keyboard_arrow_up</mat-icon>
          <mat-icon *ngIf="!showCurrent" class="dropdown-chip-close-icon" (click)="closeOpenCurrent()">keyboard_arrow_down</mat-icon>
        </div>
        <div *ngIf="showCurrent" data-qaa="current-events-list-mobile" class="sidebar-portfolio">
          <p class="text-no-event" *ngIf="currentEvents.length === 0">{{ 'DISPATCH_LIST.NO_EVENTS' | translate }}</p>
          <dsy-card card-color="#F7F8FB" height="auto" round-border="true" no-padding="true" *ngFor="let event of currentEvents; let i = index">
            <app-portfolio-card [event]="event" [index]="i" (eventNodeSelected)="handleCancelButtonInteraction($event)"></app-portfolio-card>
          </dsy-card>
        </div>
        <dsy-divider divider-orientation="horizontal" divider-color="light-grey" class="divider"></dsy-divider>
        <div class="mt-2 mb-2 container-title" data-qaa="upcoming-events-title-mobile">
          <span class="text-title"> {{ 'DISPATCH_LIST.EVENT_STATUS.UPCOMING' | translate }} ({{upcomingEvents.length}}) </span>
          <mat-icon *ngIf="showUpcoming" class="dropdown-chip-close-icon" (click)="closeOpenUpcoming()">keyboard_arrow_up</mat-icon>
          <mat-icon *ngIf="!showUpcoming" class="dropdown-chip-close-icon" (click)="closeOpenUpcoming()">keyboard_arrow_down</mat-icon>
        </div>
        <div *ngIf="showUpcoming" data-qaa="upcoming-events-list-mobile" class="sidebar-portfolio">
          <p class="text-no-event" *ngIf="upcomingEvents.length === 0">{{ 'DISPATCH_LIST.NO_EVENTS' | translate }}</p>
          <dsy-card card-color="#F7F8FB" height="auto" round-border="true" no-padding="true" *ngFor="let event of upcomingEvents; let i = index">
            <app-portfolio-card [event]="event" [index]="i" (eventNodeSelected)="handleCancelButtonInteraction($event)"></app-portfolio-card>
          </dsy-card>
        </div>
        <dsy-divider divider-orientation="horizontal" divider-color="light-grey" class="divider"></dsy-divider>
        <div class="mt-2 mb-2 container-title" data-qaa="completed-events-title-mobile">
          <span class="text-title"> {{ 'DISPATCH_LIST.EVENT_STATUS.COMPLETED' | translate }} ({{completedEvents.length}}) </span>
          <mat-icon *ngIf="showCompleted" class="dropdown-chip-close-icon" (click)="closeOpenCompleted()">keyboard_arrow_up</mat-icon>
          <mat-icon *ngIf="!showCompleted" class="dropdown-chip-close-icon" (click)="closeOpenCompleted()">keyboard_arrow_down</mat-icon>
        </div>
        <div *ngIf="showCompleted" data-qaa="completed-events-list-mobile" class="sidebar-portfolio">
          <p class="text-no-event" *ngIf="completedEvents.length === 0">{{ 'DISPATCH_LIST.NO_EVENTS' | translate }}</p>
          <dsy-card card-color="#F7F8FB" height="auto" round-border="true" no-padding="true" *ngFor="let event of completedEvents; let i = index">
            <app-portfolio-card [event]="event" [index]="i" (eventNodeSelected)="handleCancelButtonInteraction($event)"></app-portfolio-card>
          </dsy-card>
        </div>
      </dsy-card>
    </div>
  </div>
</ng-container>
